import { Routes } from '@angular/router';
import { InternalGroupChatComponent } from 'src/app/internalGroupChat/internal-group-chat/internal-group-chat.component';
import { CallFlowDetailsComponent } from 'src/app/MaterialDialogs/call-flow/call-flow-details/call-flow-details.component';
import { AuthenticationGuard } from '../../authentication.guard';
import { CustomerListComponent } from '../../pages/customer-list/customer-list.component';
import { LoginComponent } from '../../pages/login/login.component';
import { ManageVendorComponent } from '../../pages/manage-vendor/manage-vendor.component';
import { PreviewItineraryDetailComponent } from '../../pages/preview-itinerary-detail/preview-itinerary-detail.component';
import { RoleName } from './Constant';
import { HasAccessByRoleGuard } from '../../shared/guards/has-access-by-role.guard';
import { UserRoleEnum } from '@enums/user-role.enum';
import { ItineraryGuestRedirectGuard } from '../../shared/guards/itinerary-guest-redirect.guard';

export const RoutesConstant: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'service-request',
    loadChildren: () => import('../../pages/service-request/service-request.module').then((m) => m.ServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Accounting,
        RoleName.Coordinator,
        RoleName.CustomerCoordinator,
        RoleName.Accounting,
        RoleName.CustomerAdmin,
        RoleName.VendorAdmin,
        RoleName.VendorCoordinator,
        RoleName.InternalReadOnly,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'service-request-queue',
    loadChildren: () => import('../../pages/service-request-queue/service-request-queue.module').then((m) => m.ServiceRequestQueueModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.CustomerCoordinator, RoleName.CustomerAdmin, RoleName.Management],
    },
  },
  {
    path: 'service-request/:navigatestatus/:fromdate/:todate',
    loadChildren: () => import('../../pages/service-request/service-request.module').then((m) => m.ServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.CustomerAdmin, RoleName.InternalReadOnly, RoleName.Management],
    },
  },
  {
    path: 'service-request/:customerId/:navigatestatus/:fromdate/:todate',
    loadChildren: () => import('../../pages/service-request/service-request.module').then((m) => m.ServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.CustomerAdmin, RoleName.CustomerCoordinator, RoleName.Management],
    },
  },
  {
    path: 'service-request/:pageName/:customerId',
    loadChildren: () => import('../../pages/service-request/service-request.module').then((m) => m.ServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.CustomerAdmin, RoleName.CustomerCoordinator],
    },
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'create-service-request',
    loadChildren: () =>
      import('../../pages/create-service-request/create-service-request.module').then((m) => m.CreateServiceRequestModule),
    canActivate: [HasAccessByRoleGuard],
    data: {
      allowedRoles: [
        UserRoleEnum.EXECUTIVE_ADMIN,
        UserRoleEnum.COORDINATOR,
        UserRoleEnum.CUSTOMER_ADMIN,
        UserRoleEnum.CUSTOMER_COORDINATOR,
        UserRoleEnum.MANAGEMENT,
      ],
    },
  },
  {
    path: 'create-service-request/:ServiceRequestId',
    loadChildren: () =>
      import('../../pages/create-service-request/create-service-request.module').then((m) => m.CreateServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.CustomerAdmin, RoleName.Management],
    },
  },
  {
    path: 'edit-service-request/:ServiceRequestId',
    loadChildren: () =>
      import('../../pages/create-service-request/create-service-request.module').then((m) => m.CreateServiceRequestModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.Management],
    },
  },
  {
    path: 'customer-report/:ReportState',
    loadChildren: () => import('../../pages/reports/customer-report.module').then((m) => m.CustomerReportModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('../../pages/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.Management,
        RoleName.Accounting,
        RoleName.Driver,
        RoleName.CustomerAdmin,
        RoleName.CustomerCoordinator,
        RoleName.VendorAdmin,
        RoleName.VendorCoordinator,
        RoleName.VendorDriver,
        RoleName.InternalReadOnly,
      ],
    },
  },
  {
    path: 'member-list',
    loadComponent: () => import('../../pages/member-list/member-list.component'),
    canActivate: [HasAccessByRoleGuard],
    data: {
      allowedRoles: [UserRoleEnum.EXECUTIVE_ADMIN, UserRoleEnum.COORDINATOR, UserRoleEnum.INTERNAL_READONLY, UserRoleEnum.MANAGEMENT],
    },
  },
  {
    path: 'itinerary/:serviceRequestId',
    loadChildren: () => import('../../pages/itinerary/itinerary.module').then((m) => m.ItineraryModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.Management],
    },
  },
  {
    path: 'itinerary/:serviceRequestId/:fromPage',
    loadChildren: () => import('../../pages/itinerary/itinerary.module').then((m) => m.ItineraryModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.Management],
    },
  },
  {
    path: 'service-request-invoice',
    loadChildren: () =>
      import('../../pages/service-request-invoice/service-request-invoice.module').then((m) => m.ServiceRequestInvoiceModule),
  },
  {
    path: 'service-request-invoice/:serviceRequestId/:memberId/:boolValue',
    loadChildren: () =>
      import('../../pages/service-request-invoice/service-request-invoice.module').then((m) => m.ServiceRequestInvoiceModule),
  },
  {
    path: 'service-request-invoice/:groupedInvoice',
    loadChildren: () =>
      import('../../pages/service-request-invoice/service-request-invoice.module').then((m) => m.ServiceRequestInvoiceModule),
  },
  {
    path: 'manage-vehicle',
    loadChildren: () => import('../../pages/manage-vehicle/manage-vehicle.module').then((m) => m.ManageVehicleModule),
  },
  {
    path: 'customer-list',
    component: CustomerListComponent,
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.Accounting, RoleName.InternalReadOnly, RoleName.Management],
    },
  },
  {
    path: 'manage-data',
    loadComponent: () => import('../../pages/manage-data/manage-data.component'),
    canActivate: [HasAccessByRoleGuard],
    data: {
      allowedRoles: [
        UserRoleEnum.EXECUTIVE_ADMIN,
        UserRoleEnum.COORDINATOR,
        UserRoleEnum.ACCOUNTING,
        UserRoleEnum.INTERNAL_READONLY,
        UserRoleEnum.MANAGEMENT,
      ],
    },
  },
  {
    path: 'driver-dashboard',
    loadChildren: () => import('../../pages/driver-dashboard/driver-dashboard.module').then((m) => m.DriverDashboardModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.Driver,
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.VendorDriver,
        RoleName.InternalReadOnly,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'track-itinerary/:serviceRequestId/:PageName',
    component: PreviewItineraryDetailComponent,
    canActivate: [ItineraryGuestRedirectGuard],
  },
  // {
  //   path: "finance-dashboard",
  //   loadChildren: () => import('../../pages/finance-dashboard/finance-dashboard.module').then(m => m.FinanceDashboardModule),
  //   canActivate: [AuthenticationGuard],
  //   data: {
  //     role: [RoleName.ExecutiveAdmin, RoleName.Accounting, RoleName.InternalReadOnly],
  //   },
  // },
  {
    path: 'manage-vendor',
    component: ManageVendorComponent,
    canActivate: [AuthenticationGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.InternalReadOnly, RoleName.Management],
    },
  },
  {
    path: 'common-details/:fromPage/:id',
    loadChildren: () => import('../../pages/common-details-component/common-details.module').then((m) => m.CommonDetailsModule),
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.Accounting,
        RoleName.CustomerAdmin,
        RoleName.CustomerCoordinator,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'issues-feedback/:id',
    loadComponent() {
      return import('../../pages/issues-feedback/issues-feedback.component').then((m) => m.IssuesFeedbackComponent);
    },
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.Driver,
        RoleName.Accounting,
        RoleName.InternalReadOnly,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'error-submission',
    loadComponent() {
      return import('../../pages/issues-feedback/components/error-submission/error-submission.component').then(
        (m) => m.ErrorSubmissionComponent,
      );
    },
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.Driver,
        RoleName.Accounting,
        RoleName.InternalReadOnly,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'issue-details/:id',
    loadComponent() {
      return import('../../pages/issues-feedback/components/view-details/view-details.component').then((m) => m.ViewDetailsComponent);
    },
    canActivate: [AuthenticationGuard],
    data: {
      role: [
        RoleName.ExecutiveAdmin,
        RoleName.Coordinator,
        RoleName.Driver,
        RoleName.Accounting,
        RoleName.InternalReadOnly,
        RoleName.Management,
      ],
    },
  },
  {
    path: 'group-chat',
    component: InternalGroupChatComponent,
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('../../pages/privacy-policy/privacy-policy.component'),
  },
  {
    path: 'call-flow-details/:serviceRequestTypeId/:currentBusinessUnitId/:tripId',
    component: CallFlowDetailsComponent,
  },
  {
    path: 'call-flow-details/:serviceRequestTypeId/:currentBusinessUnitId',
    component: CallFlowDetailsComponent,
  },
  {
    path: 'vendor-dashboard',
    loadChildren: () => import('../../vendor/vendor.module').then((m) => m.VendorModule),
  },
  {
    path: 'businessUnit-details/:fromPage/:id',
    loadChildren: () =>
      import('../../pages/businessUnit-details-page/vendor-details/businessUnit-details.module').then((m) => m.BusinessUnitDetailsModule),
  },
  {
    path: 'vehicle-management/:id',
    loadChildren: () => import('../../vendor/vehicle/vehicle.module').then((m) => m.VehicleModule),
  },
  {
    path: 'members/:id',
    loadChildren: () => import('../../pages/members-page/members.module').then((m) => m.MembersModule),
  },
  {
    path: 'notes/:id',
    loadChildren: () => import('../../pages/notes-page/notes.module').then((m) => m.NotesModule),
  },
  {
    path: 'files/:id',
    loadChildren: () => import('../../pages/files-page/files.module').then((m) => m.FilesModule),
  },
  {
    path: 'sr-page/:id',
    loadChildren: () => import('../../vendor-customer-sr/vendor-customer-sr.module').then((m) => m.UpdatedSRModule),
  },
  {
    path: 'sr-page',
    loadChildren: () => import('../../vendor-customer-sr/vendor-customer-sr.module').then((m) => m.UpdatedSRModule),
  },
  {
    path: 'v2/customer-dashboard',
    loadComponent: () => import('../../pages/v2/dashboard-home/components/dashboard-home/dashboard-home.component'),
  },
  {
    path: 'v2/service-request-details/:serviceRequestId',
    loadChildren: () =>
      import('../../pages/v2/service-request-details/service-request-details.module').then((m) => m.ServiceRequestDetailsModule),
  },
  {
    path: 'v2/service-requests',
    loadChildren: () => import('../../pages/v2/service-requests/service-requests.module').then((m) => m.ServiceRequestsModule),
  },
  {
    path: 'v2/customer-details',
    loadChildren: () => import('../../pages/v2/customer-details/customer-details.module').then((m) => m.CustomerDetailsModule),
  },
  {
    path: 'v2/members',
    loadChildren: () => import('../../pages/v2/member/member.module').then((m) => m.MemberModule),
  },
  {
    path: 'v2/create-service-request',
    loadChildren: () =>
      import('../../pages/v2/create-service-request/create-service-request.module').then((m) => m.CreateServiceRequestModule),
    canActivate: [HasAccessByRoleGuard],
    data: {
      allowedRoles: [UserRoleEnum.CUSTOMER_COORDINATOR, UserRoleEnum.CUSTOMER_ADMIN],
    },
  },
  {
    path: 'v2/itinerary/:serviceRequestId',
    loadChildren: () => import('../../pages/v2/itinerary/itinerary.module').then((m) => m.ItineraryModule),
    canActivate: [HasAccessByRoleGuard],
    data: {
      role: [RoleName.ExecutiveAdmin, RoleName.Coordinator, RoleName.Management],
    },
  },
  {
    path: 'v2/notifications',
    loadChildren: () => import('../../pages/v2/notifications/notifications.module').then((m) => m.NotificationsModule),
  },
  {
    path: 'v2/profile',
    loadChildren: () => import('../../pages/v2/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'v2/driver-scheduling',
    loadChildren: () => import('../../pages/v2/driver-scheduling/driver-scheduling.module').then((m) => m.DriverSchedulingModule),
    data: {
      allowedRoles: [
        UserRoleEnum.EXECUTIVE_ADMIN,
        UserRoleEnum.COORDINATOR,
        UserRoleEnum.ACCOUNTING,
        UserRoleEnum.DRIVER,
        UserRoleEnum.MANAGEMENT,
        UserRoleEnum.INTERNAL_READONLY,
      ],
    },
  },
  {
    path: 'v2/reports',
    loadChildren: () => import('../../pages/v2/reports/reports.routes'),
    data: {
      allowedRoles: [
        UserRoleEnum.EXECUTIVE_ADMIN,
        UserRoleEnum.COORDINATOR,
        UserRoleEnum.ACCOUNTING,
        UserRoleEnum.INTERNAL_READONLY,
        UserRoleEnum.MANAGEMENT,
      ],
    },
  },
];
